/* src/app/FW/controls/durationpicker-entry/durationpicker-component/durationpicker.component.scss */
.time-picker-button {
  padding: 0;
  margin: 0;
  min-width: 44px;
}
/*# sourceMappingURL=durationpicker.component.css.map */
